//用户登录
export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGIN_OUT = 'USER_LOGIN_OUT'
export const GET_USER_INFO = 'GET_USER_INFO'



//表单配置
export const GET_FORM_CONFIG = 'GET_FORM_CONFIG'
export const GET_FORM_CONFIG_LOADED = 'GET_FORM_CONFIG_LOADED'
export const SET_FORM_LOADED = 'GET_FORM_LOADED'
export const SET_FLOW_LOADED = 'GET_FLOW_LOADED'
export const SET_SET_LOADED = 'GET_SET_LOADED'
export const SET_DATA_LOADED = 'GET_DATA_LOADED'

//
export const LIST_APPLICATION_ITEM = 'LIST_APPLICATION_ITEM'







// WEBPACK FOOTER //
// ./src/common/vuex/types.js